export const MAX_MOBILE_WIDTH = 767;

export const LINE_ITEM_UNITS_BASE = 'line-item/units-base';
export const LINE_ITEM_UNITS_EXTRA_GUESTS = 'line-item/units-extra-guests';
export const LINE_ITEM_WEEK_REDUCTION = 'line-item/week-reduction';
export const LINE_ITEM_CUSTOM_EXTRA = 'line-item/custom-extra-base';
export const LINE_ITEM_CUSTOMER_COMMISSION = 'line-item/customer-commission';
export const LINE_ITEM_PROVIDER_COMMISSION = 'line-item/provider-commission';
export const LINE_ITEM_PROPOSAL_PRICE = 'line-item/proposal-price';

